import React from 'react';
import {Snackbar} from "material-ui";
import {withRouter} from "react-router-dom";
import {createSubscriber} from "../actions/lead";
import { connect } from 'react-redux';
import {validateEmail} from '../helpers/index'
import {trim} from 'lodash'
import '../assets/css/dark-theme.css';


class HeroArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: ''
        }
    }

    onHandleRequestClose = () => {
        this.setState({
            snackOpen: false,
        });
    }

    onSubmit = async (e) => {
        e.preventDefault();
        const currentPath = trim(`${window.location.pathname}`,'/')
        const page = currentPath ? currentPath : 'home'
        if (await this.validate()) {
            const body = {
                email: this.state.email,
                subscription_for: page
            };
            this.setState({disabled: true});
            const res = await this.props.createSubscriber(body);
            if (res) {
                this.setState({
                    snackOpen: true,
                    email: '',
                });
            } else {
                alert('Something Went Wrong.');
            }
        }
    }

    onInputChange = (e, key) => {
        this.setState({
            [key]: e.target.value
        });
    }

    validate = async () => {
        let validateFlag = true;
        if (!validateEmail(this.state.email)) {
            validateFlag = false;
            this.setState({
                emailError: alert(`Not a valid Email`)
            });
        } else {
            this.setState({
                emailError: ''
            });
        }
        return validateFlag;
    }

    render() {
        return (
            <section className="hero-area-dark">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-6 order-lg-2 mb-5 mb-lg-0">
                            <div className="hero-image-dark">
                                <img src="images/ev_loader.png" alt="Electric Commercial Vehicle" />
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1">
                            <div className="hero-content-dark">
                                <h1>Fast, Affordable <span>Commercial EV</span> Finance</h1>
                                <p>Shifting to a new electric commercial vehicle? We are here to partner in your progress. Drive your future today with seamless financing.</p>
                                <div className="glass-form">
                                    <form onSubmit={e => this.onSubmit(e)}>
                                        <div className="form-group">
                                            <input
                                                onError={this.state.emailError}
                                                type="text"
                                                className="glass-input"
                                                placeholder="Enter your email address to get started"
                                                value={this.state.email}
                                                onChange={e => this.onInputChange(e, 'email')}
                                            />
                                            <button className="glass-btn mt-3" type="submit">
                                                Discover Options
                                            </button>
                                            <Snackbar
                                                open={this.state.snackOpen}
                                                message='Thank you for Subscription'
                                                autoHideDuration={4000}
                                                onRequestClose={this.onHandleRequestClose}
                                            />
                                        </div>
                                    </form>
                                </div>
                                <div className="row mt-4 pl-3">
                                    <a href="https://play.google.com/store/apps/details?id=com.lcgm.ascend_loan" className="download-app-dark">
                                        <img src="images/download_ascend_app.jpg" alt="Download Ascend App" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    createSubscriber: body => dispatch(createSubscriber(body)),
});

export default withRouter(connect(null, mapDispatchToProps)(HeroArea));



// WEBPACK FOOTER //
// ./src/components/HeroArea.js